/**
 * Cart drawer feedback.
 *
 * Horizon updates the cart by re-rendering the whole drawer through the
 * Section Rendering API. That round trip takes a moment, and until it
 * lands the quantity buttons look inert — you press +, nothing moves,
 * then the panel jumps. This marks the control you pressed as busy so
 * the wait is visible, and softens the swap so the new markup fades in
 * instead of snapping.
 *
 * No state to clean up: the re-render replaces these nodes outright.
 */
(() => {
  const BUSY = 'data-sol-busy';
  const SETTLING = 'data-sol-settling';

  /** Mark the pressed quantity control, and the panel, as working. */
  function markBusy(el) {
    const control = el.closest('.cart-items__quantity-controls, .cart-items__quantity');
    if (control) control.setAttribute(BUSY, 'true');

    const panel = el.closest('.cart-drawer__inner, cart-items-component');
    if (panel) panel.setAttribute(BUSY, 'true');
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.quantity-plus, .quantity-minus, .cart-items__remove, [name="minus"], [name="plus"]');
      if (button) markBusy(button);
    },
    { capture: true }
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest('.cart-items__quantity input, input[name="updates[]"]');
      if (input) markBusy(input);
    },
    { capture: true }
  );

  /**
   * When Shopify swaps in fresh drawer markup, fade it up briefly so the
   * progress bar growing and the totals changing read as one movement
   * rather than three separate flashes.
   */
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        const inner = node.matches?.('.cart-drawer__inner')
          ? node
          : node.querySelector?.('.cart-drawer__inner');
        if (!inner) continue;

        inner.setAttribute(SETTLING, 'true');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => inner.removeAttribute(SETTLING));
        });
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
